import { Layout } from 'antd';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { useApp } from '@/contexts';

import './styles.scss';

import Sidebar from '../Sidebar';
import Topbar from '../Topbar';

const { Header, Content, Sider } = Layout;

const AppLayout = () => {
  const { selectedRegion, selectedCropSeason } = useApp();
  const scopeKey = `${selectedRegion}:${selectedCropSeason}`;

  return (
    <Layout>
      <Header>
        <Topbar />
      </Header>
      <Layout>
        <Sider width='auto' collapsedWidth='auto' trigger={null}>
          <Sidebar />
        </Sider>
        <Content>
          <Suspense fallback=''>
            <Outlet key={scopeKey} />
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
